
import { useNavigate, useLocation } from "react-router-dom";
import API_BASE_URL from "../../Constants"

export const UserCard = ({ user, onClose, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();



  const clearUserLocks = async (user) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/record/${encodeURIComponent(user)}/clear-locks`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        const message = await response.text(); // Get the response message
        console.log('Server response:', message); // Logs the response from the server
      } else {
        throw new Error('Failed to clear locks');
      }
    } catch (error) {
      console.error('An error occurred:', error.message);
    }
  };

  const handleNavigation = () => {

    if (location.pathname.startsWith("/approver-dashboard")) {
      navigate('/approver-dashboard/profile');
    } else {
      navigate('/user/profile', { state: { user: user } });
    }

    onClose();
  }


  return (
    <div className="absolute top-16 w-auto right-0 bg-white shadow-md p-4 px-12 rounded-md m-4 flex flex-col items-center">
      <button onClick={onClose} className="absolute top-2 right-2 text-gray-500">
        <img src="/assets/navbar/user-card-x.png" alt="Close" />
      </button>
      <div className="flex flex-col items-center mb-4">
        <img src={user.profilePictureUrl}
          alt="User Avatar"
          className="h-12 w-12 rounded-full mb-2" />
        <div className="text-center">
          <h3 className="text-lg font-semibold">{user.username}</h3>
          <p className="text-sm text-gray-600">{user.email}</p>
        </div>
      </div>
      <div className="w-full flex flex-col items-center space-y-2">
        <button className="w-full">
          <h1 className="py-1 px-10 border border-gray-300 rounded-3xl text-sm text-blue-500 w-full text-center">
            Account Settings
          </h1>
        </button>
        <button className="w-full" onClick={handleNavigation}>
          <h1 className="py-1 border border-gray-300 rounded-3xl text-sm text-blue-500 w-full text-center">
            Profile
          </h1>
        </button>
        <button className="w-full" onClick={() => { clearUserLocks(user.username); onLogout(); }}>
          <h1 className="py-1 border border-gray-300 rounded-2xl text-sm text-red-500 w-full text-center">
            Sign out
          </h1>
        </button>
      </div>
    </div>
  );
};
